import * as httpConst from "@/constants/httpConst";
import Vue from "vue";

/**
 * 報告不要業者データ補完
 */
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/none_report_trader_complements`

const getDefaultState = () => {
  return {}
}

const transferNoneReportTraderComplement = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 報告不要業者データ補完一覧
     * @param params {Object}
     * @param params.jwnet_manifest_ids {Array} JWNETマニフェスト_IDの配列
     */
    index ({ commit }, {params}) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  }
}

export default transferNoneReportTraderComplement;

